import { axios } from 'data';
import { Uuid } from 'types/common';
import { Invoice, InvoiceBasic } from 'types/models';
import { InvoiceCreateParams, InvoiceCreateResponse, InvoicesParams, InvoicesResponse } from 'types/services';

import { preparePaginatableParams, preparePaginatedData, prepareTimezonableParams } from './helpers';

const getInvoices = async (params: InvoicesParams = {}) => {
  params = preparePaginatableParams(params);
  params = prepareTimezonableParams(params);

  const response = await axios.get<InvoicesResponse>('/transaction', { params });

  return preparePaginatedData<Invoice>(response.data);
};

const getInvoice = async (id: Uuid) => {
  const response = await axios.get<Invoice>(`/transaction/${id}`);

  return response.data;
};

const getInvoiceBasic = async (displayId: string) => {
  const response = await axios.get<InvoiceBasic>(`/invoice/${displayId}`);

  return { ...response.data, displayId };
};

const createInvoice = async (params: InvoiceCreateParams) => {
  const response = await axios.post<InvoiceCreateResponse>('/invoice/generate', params);

  return response.data;
};

const invoiceService = {
  getInvoices,
  getInvoice,
  getInvoiceBasic,
  createInvoice,
};

export default invoiceService;
